import { useTheme } from 'styled-components';

import { Close } from '@gympass/yoga-icons';
import ReactModal from 'react-modal';

import { ModalProps } from './types';

import * as S from './styles';

const Modal: React.FC<ModalProps> = ({
  isOpen,
  children,
  closeModal,
  overlayStyle,
  contentStyle,
  showCloseButton = true,
  ...rest
}) => {
  const theme = useTheme() as any; // eslint-disable-line

  const appElement = document.getElementById('root');

  if (!appElement) return null;

  return (
    <ReactModal
      appElement={appElement}
      isOpen={isOpen}
      onRequestClose={() => closeModal()}
      style={{
        overlay: {
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, .50)',
          display: 'grid',
          justifyItems: 'center',
          zIndex: 4,
          ...overlayStyle,
        },
        content: {
          boxShadow: `${theme.yoga.elevations.medium}`,
          inset: 'unset',
          margin: `${theme.yoga.spacing.xxlarge}px`,
          maxHeight: `calc(100vh - (${theme.yoga.spacing.xxlarge * 2}px))`,
          maxWidth: `calc(100vw - (${theme.yoga.spacing.xxlarge * 2}px))`,
          paddingBottom: `${theme.yoga.spacing.xxlarge}px`,
          paddingTop: `${theme.yoga.spacing.xxxlarge}px`,
          position: 'relative',
          height: 'fit-content',
          ...contentStyle,
        },
      }}
      {...rest}
    >
      {showCloseButton && (
        <S.CloseIcon
          role="button"
          aria-label="Close modal"
          data-testid="closeButton"
          onClick={() => closeModal()}
        >
          <Close
            width="22px"
            height="22px"
            strokeWidth="0"
            viewBox="2 2 8 8"
            fill={theme.yoga.colors.primary}
          />
        </S.CloseIcon>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
